import { useTranslation } from "react-i18next"
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useStore } from '../contexts/store'
import React from "react"
import api from "../api/api"
import { alert } from "../stores/alertStore"

// message from thread
const TrialDialog = ({open, handleClose }: {open: boolean, handleClose: any }) => {
  const { t } = useTranslation()
  const { sessionStore, alertStore } = useStore()
  const [name, setName] = React.useState<string|null>(sessionStore.session?.user.idpProvidedUserName||null)
  const [email, setEmail] = React.useState<string|null>('')
  const [reason, setReason] = React.useState<string|null>('')
  const [status, setStatus] = React.useState<string>('')

  return <Dialog open={open} sx={{zIndex: 1501}}>
  <DialogTitle>{t('SHRIMP Trial')}</DialogTitle>
  <DialogContent>

    <p>{t('Regardless of whether you are a teacher looking to use SHRIMP for their teaching or a student looking to set up a working group, we will gladly upgrade your account so you can try out SHRIMP. This will allow you to create pods and upload materials. We will also contact you with additional information and will, in return for the upgrade, ask you about your experience using SHRIMP.')}</p>
    <p>{t('As part of the upgrade process, you will be logged out and will have to log in again.')}</p>
    <Box sx={{mb:1, mt:4}}><TextField value={name}  required onChange={(e) => { setName(e.target.value) }} fullWidth label={t("Your name")} /></Box>
    <Box sx={{mb:1, mt:1}}><TextField value={email} required onChange={(e) => { setEmail(e.target.value) }} fullWidth label={t("Your email address")} /></Box>
    <Box sx={{mb:1, mt:1}}><TextField value={reason} onChange={(e) => { setReason(e.target.value) }} fullWidth label={t('What context or teaching scenario do you have in mind?')} multiline /></Box>
    {status === 'sending' && <Alert severity="info">{t('Sending your request')}</Alert>}
  </DialogContent>
  <DialogActions style={{textAlign:'right'}}>
  <Button onClick={() => {handleClose()}}>{t('Cancel')}</Button>
  <Button variant='contained' disabled={!(Boolean(email) && (email?.indexOf('@') && email?.indexOf('@')>0) && Boolean(name))} onClick={async ()=>{
    // submit
    setStatus('sending')
    try {
      const r = await api.upgradeUser(sessionStore.session?.sessionId || 'no session found', {
        form: 'SHRIMP Trial',
        userId: sessionStore.session?.user.userId,
        name,
        email,
        reason
      })
      if (r && r.status === 200) {
        alertStore.push(alert(t('Upgrade initiated. You will need to log in again for changes to take effect.'), 'success'))
        handleClose()
      }
      else {
        alertStore.push(alert(t('Could not send request. Please contact us via email at info@shrimpp.de'), 'error'))
        setStatus('Error')
      }
      setStatus('')
    }
    catch(e) {
      //i18next.t
      alertStore.push(alert(t('Could not send request. Please contact us via email at info@shrimpp.de'), 'error'))
    }
  }}>{t('OK')}</Button>
  </DialogActions>
</Dialog>

}

export default TrialDialog